(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var GUIDE_SEEN_STORAGE_KEY = sbbNamespace.guideSeenStorageKey;
  if (!ScaleBarBuilder || !clamp || !GUIDE_SEEN_STORAGE_KEY) {
    return;
  }

ScaleBarBuilder.prototype.getGuideSteps = function (mode) {
    if (String(mode || '').toLowerCase() === 'in-depth') {
      return this.getInDepthGuideSteps();
    }
    return [
      {
        title: 'Welcome',
        body: 'This quick guide follows the shelf from top to bottom so each control is introduced in layout order.'
      },
      {
        title: 'Top Shelf Actions',
        body: 'Start here: template load, reset, share, guide launchers, and export.',
        target: function (app) {
          return app.controls.mainShelf ? app.controls.mainShelf.querySelector('.sbb-main-shelf-top') : null;
        }
      },
      {
        title: 'Settings Panel',
        body: 'Use Settings for software preset, target family, paper, units, cut margin, and snap grid values.',
        target: function (app) { return app.controls.settingsMenu || app.controls.mainShelf; }
      },
      {
        title: 'Advanced Sections',
        body: 'Open Advanced to access command output, full controls, and design import/export.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.advancedControls || app.controls.sidebar;
        }
      },
      {
        title: 'Command Output',
        body: 'Validate generated command/script output and CSV coordinates before export.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.commandOutput || app.controls.usedTagCsv || app.controls.advancedControls;
        }
      },
      {
        title: 'Canvas Toolbar',
        body: 'Use Add Reference/Text/Image/Tag/Shape, noise controls, and HOME controls from this toolbar.',
        target: function (app) { return app.controls.previewToolbar || app.canvas; }
      },
      {
        title: 'Add New Markers',
        html: [
          '<div class="sbb-guide-mini">',
          '  <div class="sbb-guide-mini-tag sbb-guide-mini-tag-left"></div>',
          '  <div class="sbb-guide-mini-dot"></div>',
          '  <div class="sbb-guide-mini-cursor"></div>',
          '</div>',
          '<p>When placement guides are visible, click the blue dot next to a selected tag to add the next marker.</p>'
        ].join(''),
        target: function (app) { return app.canvas; }
      },
      {
        title: 'Selection Shelf',
        body: 'Select a tag and adjust size in the quick shelf. Use Apply Size to All for uniform targets.',
        target: function (app) {
          app.ensureGuideTagShelfSelection();
          return app.getGuideTagShelfTarget();
        }
      }
    ];
  };

  ScaleBarBuilder.prototype.getInDepthGuideSteps = function () {
    return [
      {
        title: 'In-Depth Guide',
        body: 'This in-depth walkthrough also follows shelf order top-to-bottom, then moves through advanced workflows.'
      },
      {
        title: 'Top Shelf Actions',
        body: 'Template management, reset, share, guide launchers, and export controls are here.',
        target: function (app) {
          return app.controls.mainShelf ? app.controls.mainShelf.querySelector('.sbb-main-shelf-top') : null;
        }
      },
      {
        title: 'Settings Panel',
        body: 'Configure software, family, paper, units, cut margin, and snap from the top shelf settings.',
        target: function (app) { return app.controls.settingsMenu || app.controls.mainShelf; }
      },
      {
        title: 'Margins For Simple Scale Bars',
        body: 'Use Cut Margin and Print Margin to preserve white borders and prevent clipping.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.cutMargin || app.controls.printMargin || app.controls.settingsMenu || app.controls.advancedControls || app.canvas;
        },
        canvasDemo: { type: 'margins' }
      },
      {
        title: 'Advanced Controls',
        body: 'Advanced sections hold command output, ID checks, offsets, and deeper configuration.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.advancedControls || app.controls.sidebar;
        }
      },
      {
        title: 'Command + CSV Precision',
        body: 'Review command output and CSV coordinates here to confirm high-precision values.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.commandOutput || app.controls.usedTagCsv || app.controls.advancedControls;
        }
      },
      {
        title: 'Canvas Toolbar',
        body: 'Canvas tools drive advanced composition: references, shapes, tags, and noise controls.',
        target: function (app) { return app.controls.previewToolbar || app.canvas; }
      },
      {
        title: 'Canvas Noise',
        body: 'Use Noise Settings to enable grain, tune size/contrast, and keep labels readable with white backing boxes.',
        target: function (app) {
          app.state.selectedEntity = { type: 'noise', id: 'background-noise' };
          app.renderSelectionShelf();
          return app.controls.noiseSettings || app.controls.toggleBackgroundNoise || app.controls.previewToolbar || app.canvas;
        },
        canvasDemo: { type: 'noise' }
      },
      {
        title: 'Adding Shapes',
        body: 'Use Add Shape for compass markers, circles, and helper graphics; style them in the selection shelf.',
        target: function (app) { return app.controls.addShape || app.controls.previewToolbar || app.canvas; },
        canvasDemo: { type: 'add-shapes' }
      },
      {
        title: 'Reference Ruler Styles',
        body: 'Select a reference ruler and switch Style (Checker, Invert, Dashed, Ticks, Blocks).',
        target: function (app) {
          app.ensureGuideReferenceSelection();
          return app.getGuideReferenceStyleTarget();
        },
        canvasDemo: { type: 'ruler-style' }
      },
      {
        title: 'Circular Cut Lines',
        body: 'Set cut mode to Circle, then size it by drag handle or diameter input.',
        target: function (app) {
          app.ensureGuideCutShelfSelection('circle');
          return app.controls.selectionShelf || app.canvas;
        },
        canvasDemo: { type: 'circle-cut' }
      },
      {
        title: 'Custom Cut Lines',
        body: 'Set cut mode to Manual, click Draw, place points, drag for bezier handles, and close the loop on point one.',
        target: function (app) {
          app.ensureGuideCutShelfSelection('manual');
          return app.controls.selectionShelf || app.canvas;
        },
        canvasDemo: { type: 'manual-cut' }
      },
      {
        title: 'Precision Validation',
        body: 'Final QA: after any move, verify distance labels and exported coordinates still match true geometry.',
        target: function (app) {
          app.ensureGuideAdvancedVisible();
          return app.controls.commandOutput || app.controls.usedTagCsv || app.controls.advancedControls || app.canvas;
        }
      }
    ];
  };

  ScaleBarBuilder.prototype.resolveGuideTarget = function (step) {
    if (!step) {
      return null;
    }
    if (typeof step.target === 'function') {
      return step.target(this) || null;
    }
    if (typeof step.target === 'string') {
      return this.root.querySelector(step.target);
    }
    return null;
  };

  ScaleBarBuilder.prototype.ensureGuideTagShelfSelection = function () {
    if (!this.state.tags || !this.state.tags.length) {
      return;
    }
    var selected = this.state.selectedEntity;
    if (selected && selected.type === 'tag' && typeof selected.id === 'number' && selected.id >= 0 && selected.id < this.state.tags.length) {
      return;
    }
    this.state.selectedEntity = { type: 'tag', id: 0 };
    this.renderSelectionShelf();
  };

  ScaleBarBuilder.prototype.getGuideTagShelfTarget = function () {
    if (!this.controls.selectionShelf) {
      return null;
    }
    var sizeField = this.controls.selectionShelf.querySelector('[data-shelf-field="tagSize"]');
    if (sizeField) {
      return sizeField.closest('.sbb-shelf-row') || sizeField;
    }
    return this.controls.selectionShelf.querySelector('[data-shelf-action="tag-apply-size-all"]')
      || this.controls.selectionShelf;
  };

  ScaleBarBuilder.prototype.ensureGuideReferenceSelection = function () {
    var paper = this.getPaper();
    var points = this.getCurrentPoints();
    this.ensureDefaultReferenceBar(points, paper);
    if (!Array.isArray(this.state.references) || !this.state.references.length) {
      return;
    }
    var selected = this.state.selectedEntity;
    if (selected && selected.type === 'reference' && this.getReferenceById(selected.id)) {
      this.renderSelectionShelf();
      return;
    }
    this.state.selectedEntity = { type: 'reference', id: this.state.references[0].id };
    this.renderSelectionShelf();
  };

  ScaleBarBuilder.prototype.ensureGuideAdvancedVisible = function () {
    if (!this.controls.advancedControls) {
      return;
    }
    if (this.state.sidebarCollapsed) {
      this.state.sidebarCollapsed = false;
      this.applySidebarCollapsedState();
      this.resizeCanvas();
    }
  };

  ScaleBarBuilder.prototype.ensureGuideCutShelfSelection = function (mode) {
    var nextMode = mode === 'circle' ? 'circle' : 'manual';
    var changed = false;

    if (!this.state.selectedEntity || this.state.selectedEntity.type !== 'cut') {
      this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
      changed = true;
    }
    if (this.state.cutShapeMode !== nextMode) {
      this.state.cutShapeMode = nextMode;
      changed = true;
    }
    this.state.cutEditMode = 'manual';

    if (nextMode === 'manual') {
      var manual = this.getCutManualState();
      if (manual.tool !== 'draw' && !manual.closed) {
        manual.tool = 'draw';
        this.state.cutManual = manual;
        changed = true;
      }
    } else {
      this.manualCutPreviewPointerMm = null;
    }

    if (changed) {
      this.renderSelectionShelf();
    }
  };

  ScaleBarBuilder.prototype.getGuideReferenceStyleTarget = function () {
    if (this.controls.selectionShelf) {
      var styleField = this.controls.selectionShelf.querySelector('[data-shelf-field="style"]');
      if (styleField) {
        return styleField.closest('.sbb-shelf-row') || styleField;
      }
    }
    if (this.controls.inspector) {
      var inspectorStyle = this.controls.inspector.querySelector('[data-inspector-field="style"]');
      if (inspectorStyle) {
        return inspectorStyle.closest('.sbb-field') || inspectorStyle;
      }
    }
    return this.controls.selectionShelf || this.canvas;
  };

  ScaleBarBuilder.prototype.clearGuideHighlight = function () {
    if (this.guideHighlightElement) {
      this.guideHighlightElement.classList.remove('sbb-guide-highlight');
      this.guideHighlightElement = null;
    }
  };

  ScaleBarBuilder.prototype.clearGuideSpotlight = function () {
    if (!this.controls.guideSpotlight) {
      return;
    }
    if (this.controls.guideOverlay) {
      this.controls.guideOverlay.classList.remove('is-spotlight-active');
    }
    this.controls.guideSpotlight.style.display = 'none';
    this.controls.guideSpotlight.style.left = '';
    this.controls.guideSpotlight.style.top = '';
    this.controls.guideSpotlight.style.width = '';
    this.controls.guideSpotlight.style.height = '';
    this.controls.guideSpotlight.style.borderRadius = '';
  };

  ScaleBarBuilder.prototype.positionGuideSpotlight = function (target) {
    if (!this.controls.guideSpotlight || !this.controls.guideOverlay || this.controls.guideOverlay.hidden || !this.guideActive) {
      this.clearGuideSpotlight();
      return;
    }
    if (!target || typeof target.getBoundingClientRect !== 'function') {
      this.clearGuideSpotlight();
      return;
    }

    var rect = target.getBoundingClientRect();
    var viewportWidth = Math.max(window.innerWidth || 0, document.documentElement ? document.documentElement.clientWidth : 0);
    var viewportHeight = Math.max(window.innerHeight || 0, document.documentElement ? document.documentElement.clientHeight : 0);
    if (!viewportWidth || !viewportHeight || rect.width <= 0 || rect.height <= 0) {
      this.clearGuideSpotlight();
      return;
    }

    var pad = 6;
    var minEdge = 2;
    var left = clamp(rect.left - pad, minEdge, viewportWidth - minEdge);
    var top = clamp(rect.top - pad, minEdge, viewportHeight - minEdge);
    var right = clamp(rect.right + pad, left + 4, viewportWidth - minEdge);
    var bottom = clamp(rect.bottom + pad, top + 4, viewportHeight - minEdge);
    var width = right - left;
    var height = bottom - top;

    if (width < 4 || height < 4) {
      this.clearGuideSpotlight();
      return;
    }

    if (this.controls.guideOverlay) {
      this.controls.guideOverlay.classList.add('is-spotlight-active');
    }
    var radius = Math.round(clamp(Math.min(width, height) * 0.2, 6, 14));
    this.controls.guideSpotlight.style.display = 'block';
    this.controls.guideSpotlight.style.left = Math.round(left) + 'px';
    this.controls.guideSpotlight.style.top = Math.round(top) + 'px';
    this.controls.guideSpotlight.style.width = Math.round(width) + 'px';
    this.controls.guideSpotlight.style.height = Math.round(height) + 'px';
    this.controls.guideSpotlight.style.borderRadius = radius + 'px';
  };

  ScaleBarBuilder.prototype.positionGuideCard = function (target) {
    if (!this.controls.guideCard || !this.controls.guideOverlay || this.controls.guideOverlay.hidden) {
      return;
    }
    var card = this.controls.guideCard;
    var margin = 12;
    var cardRect = card.getBoundingClientRect();
    var viewportWidth = Math.max(window.innerWidth || 0, document.documentElement ? document.documentElement.clientWidth : 0);
    var viewportHeight = Math.max(window.innerHeight || 0, document.documentElement ? document.documentElement.clientHeight : 0);
    var minX = margin;
    var maxX = Math.max(margin, viewportWidth - cardRect.width - margin);
    var minY = margin;
    var maxY = Math.max(margin, viewportHeight - cardRect.height - margin);
    if (this.root && typeof this.root.getBoundingClientRect === 'function') {
      var rootRect = this.root.getBoundingClientRect();
      if (rootRect && rootRect.width > 24 && rootRect.height > 24) {
        minX = clamp(rootRect.left + margin, margin, maxX);
        maxX = clamp(rootRect.right - cardRect.width - margin, minX, maxX);
        minY = clamp(rootRect.top + margin, margin, maxY);
        maxY = clamp(rootRect.bottom - cardRect.height - margin, minY, maxY);
      }
    }
    var x = margin;
    var y = margin;

    function clampPos(px, py) {
      return {
        x: clamp(px, minX, maxX),
        y: clamp(py, minY, maxY)
      };
    }

    function overlapArea(a, b) {
      var left = Math.max(a.left, b.left);
      var right = Math.min(a.right, b.right);
      var top = Math.max(a.top, b.top);
      var bottom = Math.min(a.bottom, b.bottom);
      if (right <= left || bottom <= top) {
        return 0;
      }
      return (right - left) * (bottom - top);
    }

    if (target && typeof target.getBoundingClientRect === 'function') {
      var rect = target.getBoundingClientRect();
      var targetCenterX = rect.left + (rect.width / 2);
      var targetCenterY = rect.top + (rect.height / 2);
      var candidates = [
        { x: rect.right + margin, y: rect.top, placement: 'right' },
        { x: rect.left - cardRect.width - margin, y: rect.top, placement: 'left' },
        { x: rect.left, y: rect.bottom + margin, placement: 'below' },
        { x: rect.left, y: rect.top - cardRect.height - margin, placement: 'above' },
        { x: rect.right - cardRect.width, y: rect.bottom + margin, placement: 'below-right' },
        { x: rect.right - cardRect.width, y: rect.top - cardRect.height - margin, placement: 'above-right' }
      ];

      var best = null;
      for (var i = 0; i < candidates.length; i += 1) {
        var candidate = candidates[i];
        var clamped = clampPos(candidate.x, candidate.y);
        var cardBox = {
          left: clamped.x,
          top: clamped.y,
          right: clamped.x + cardRect.width,
          bottom: clamped.y + cardRect.height
        };
        var overlap = overlapArea(cardBox, rect);
        var clampShift = Math.abs(clamped.x - candidate.x) + Math.abs(clamped.y - candidate.y);
        var cardCenterX = clamped.x + (cardRect.width / 2);
        var cardCenterY = clamped.y + (cardRect.height / 2);
        var distance = Math.hypot(cardCenterX - targetCenterX, cardCenterY - targetCenterY);
        var score = (overlap * 1000000) + (clampShift * 1000) - distance;
        if (!best || score < best.score) {
          best = {
            x: clamped.x,
            y: clamped.y,
            score: score
          };
        }
      }

      if (best) {
        x = best.x;
        y = best.y;
      }
    } else {
      x = maxX;
      y = minY;
    }

    card.style.left = Math.round(x) + 'px';
    card.style.top = Math.round(y) + 'px';
  };

  ScaleBarBuilder.prototype.renderGuideStep = function () {
    if (!this.guideActive || !this.controls.guideOverlay) {
      return;
    }
    var step = this.guideSteps[this.guideStepIndex];
    if (!step) {
      this.stopGuide(true);
      return;
    }

    var modeLabel = this.guideMode === 'in-depth' ? 'In-Depth' : 'Quick';
    this.controls.guideStepIndex.textContent = modeLabel + ' | Step ' + (this.guideStepIndex + 1) + ' of ' + this.guideSteps.length;
    this.controls.guideTitle.textContent = step.title || 'Guide';
    if (typeof step.html === 'string' && step.html.trim()) {
      this.controls.guideBody.innerHTML = step.html;
    } else {
      this.controls.guideBody.textContent = step.body || '';
    }
    this.controls.guideBack.disabled = this.guideStepIndex === 0;
    this.controls.guideNext.textContent = this.guideStepIndex >= this.guideSteps.length - 1 ? 'Finish' : 'Next';

    var target = this.resolveGuideTarget(step);
    this.clearGuideHighlight();
    if (target) {
      this.guideHighlightElement = target;
      target.classList.add('sbb-guide-highlight');
      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
    this.positionGuideSpotlight(target);
    this.positionGuideCard(target);
    this.scheduleGuideAnimation();
  };

  ScaleBarBuilder.prototype.updateGuideAfterRender = function () {
    if (!this.guideActive || !this.controls.guideOverlay || this.controls.guideOverlay.hidden) {
      return;
    }
    var step = this.guideSteps[this.guideStepIndex];
    var target = this.resolveGuideTarget(step);
    if (target !== this.guideHighlightElement) {
      this.clearGuideHighlight();
      if (target) {
        this.guideHighlightElement = target;
        target.classList.add('sbb-guide-highlight');
      }
    }
    this.positionGuideSpotlight(target);
    this.positionGuideCard(target);
  };

  ScaleBarBuilder.prototype.clearGuideAnimationTimer = function () {
    if (this.guideAnimationTimer) {
      clearTimeout(this.guideAnimationTimer);
      this.guideAnimationTimer = null;
    }
  };

  ScaleBarBuilder.prototype.scheduleGuideAnimation = function () {
    this.clearGuideAnimationTimer();
    if (!this.guideActive || this._destroyed) {
      return;
    }
    var step = this.guideSteps[this.guideStepIndex];
    if (!step || !step.canvasDemo || this.isExportRender) {
      return;
    }
    var self = this;
    this.guideAnimationTimer = setTimeout(function () {
      self.guideAnimationTimer = null;
      if (!self.guideActive || self._destroyed) {
        return;
      }
      self.render();
      self.scheduleGuideAnimation();
    }, 85);
  };

  ScaleBarBuilder.prototype.drawGuideCanvasDemo = function (ctx, view, paper, widthPx, heightPx) {
    if (!this.guideActive || this.isExportRender) {
      return;
    }
    var step = this.guideSteps[this.guideStepIndex];
    if (!step || !step.canvasDemo) {
      return;
    }
    var demoType = typeof step.canvasDemo === 'string' ? step.canvasDemo : step.canvasDemo.type;
    if (!demoType) {
      return;
    }

    var t = (Date.now() % 2200) / 2200;
    var pulse = 0.5 + 0.5 * Math.sin(t * Math.PI * 2);
    var pad = Math.max(8, 5 * this.pixelRatio);
    var panelW = Math.max(136, 104 * this.pixelRatio);
    var panelH = Math.max(86, 62 * this.pixelRatio);
    var panelX = widthPx - panelW - pad;
    var panelY = pad;
    var lineW = Math.max(1, 0.1 * this.pixelRatio);
    var demoPixelRatio = this.pixelRatio;

    var drawCaption = function (text) {
      ctx.save();
      ctx.fillStyle = 'rgba(31, 41, 51, 0.92)';
      ctx.font = Math.max(8, 7 * demoPixelRatio) + 'px "IBM Plex Mono", monospace';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(text, panelX + 7 * demoPixelRatio, panelY + 5 * demoPixelRatio);
      ctx.restore();
    };

    ctx.save();
    ctx.globalAlpha = 0.94;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
    ctx.strokeStyle = 'rgba(22, 101, 216, 0.68)';
    ctx.lineWidth = lineW;
    ctx.fillRect(panelX, panelY, panelW, panelH);
    ctx.strokeRect(panelX, panelY, panelW, panelH);

    if (demoType === 'noise') {
      drawCaption('Noise controls');
      var nx = panelX + 8 * this.pixelRatio;
      var ny = panelY + 18 * this.pixelRatio;
      var nw = panelW - 16 * this.pixelRatio;
      var nh = panelH - 26 * this.pixelRatio;
      var cols = 18;
      var rows = 10;
      for (var r = 0; r < rows; r += 1) {
        for (var c = 0; c < cols; c += 1) {
          var v = Math.sin((c * 1.1 + r * 0.77 + t * 9.2)) * 0.5 + 0.5;
          var shade = Math.round(178 + v * 64);
          ctx.fillStyle = 'rgb(' + shade + ',' + shade + ',' + shade + ')';
          ctx.fillRect(nx + (c * nw) / cols, ny + (r * nh) / rows, nw / cols + 1, nh / rows + 1);
        }
      }
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.9)';
      ctx.lineWidth = Math.max(1, 0.12 * this.pixelRatio);
      ctx.beginPath();
      ctx.moveTo(nx + 8, ny + nh - 10);
      ctx.lineTo(nx + nw - 8, ny + nh - 10);
      ctx.stroke();
      var knobX = nx + 8 + (nw - 16) * (0.2 + 0.6 * pulse);
      ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
      ctx.beginPath();
      ctx.arc(knobX, ny + nh - 10, Math.max(2.2, 1.7 * this.pixelRatio), 0, Math.PI * 2);
      ctx.fill();
    } else if (demoType === 'manual-cut') {
      drawCaption('Manual cut path');
      var mx = panelX + 10 * this.pixelRatio;
      var my = panelY + 22 * this.pixelRatio;
      var mw = panelW - 20 * this.pixelRatio;
      var mh = panelH - 30 * this.pixelRatio;
      var p0 = { x: mx + mw * 0.12, y: my + mh * 0.74 };
      var p1 = { x: mx + mw * 0.42, y: my + mh * 0.18 };
      var p2 = { x: mx + mw * 0.84, y: my + mh * 0.28 };
      var p3 = { x: mx + mw * 0.76, y: my + mh * 0.78 };
      ctx.strokeStyle = 'rgba(192, 86, 33, 0.95)';
      ctx.lineWidth = Math.max(1, 0.13 * this.pixelRatio);
      ctx.setLineDash([4 * this.pixelRatio, 3 * this.pixelRatio]);
      ctx.beginPath();
      ctx.moveTo(p0.x, p0.y);
      ctx.lineTo(p1.x, p1.y);
      ctx.bezierCurveTo(mx + mw * 0.56, my + mh * 0.06, mx + mw * 0.72, my + mh * 0.64, p2.x, p2.y);
      ctx.lineTo(p3.x, p3.y);
      ctx.closePath();
      ctx.stroke();
      ctx.setLineDash([]);
      var points = [p0, p1, p2, p3];
      for (var pi = 0; pi < points.length; pi += 1) {
        ctx.fillStyle = 'rgba(22, 101, 216, 0.96)';
        ctx.beginPath();
        ctx.arc(points[pi].x, points[pi].y, Math.max(2, 1.5 * this.pixelRatio), 0, Math.PI * 2);
        ctx.fill();
      }
      var cursorX = mx + mw * (0.2 + 0.55 * pulse);
      var cursorY = my + mh * (0.82 - 0.55 * pulse);
      ctx.strokeStyle = 'rgba(15, 23, 42, 0.92)';
      ctx.lineWidth = Math.max(1, 0.11 * this.pixelRatio);
      ctx.beginPath();
      ctx.moveTo(cursorX - 3 * this.pixelRatio, cursorY - 3 * this.pixelRatio);
      ctx.lineTo(cursorX + 3 * this.pixelRatio, cursorY + 3 * this.pixelRatio);
      ctx.moveTo(cursorX + 3 * this.pixelRatio, cursorY - 3 * this.pixelRatio);
      ctx.lineTo(cursorX - 3 * this.pixelRatio, cursorY + 3 * this.pixelRatio);
      ctx.stroke();
    } else if (demoType === 'circle-cut') {
      drawCaption('Circular cut');
      var cx = panelX + panelW * 0.5;
      var cy = panelY + panelH * 0.58;
      var cr = Math.min(panelW, panelH) * (0.28 + 0.03 * pulse);
      ctx.strokeStyle = 'rgba(192, 86, 33, 0.95)';
      ctx.lineWidth = Math.max(1, 0.12 * this.pixelRatio);
      ctx.setLineDash([5 * this.pixelRatio, 3 * this.pixelRatio]);
      ctx.beginPath();
      ctx.arc(cx, cy, cr, 0, Math.PI * 2);
      ctx.stroke();
      ctx.setLineDash([]);
      var handleAngle = -Math.PI / 6;
      var hx = cx + Math.cos(handleAngle) * cr;
      var hy = cy + Math.sin(handleAngle) * cr;
      ctx.fillStyle = 'rgba(22, 101, 216, 0.96)';
      ctx.beginPath();
      ctx.arc(hx, hy, Math.max(2.2, 1.7 * this.pixelRatio), 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.64)';
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(hx, hy);
      ctx.stroke();
    } else if (demoType === 'add-shapes') {
      drawCaption('Add shape + edit');
      var sx = panelX + 12 * this.pixelRatio;
      var sy = panelY + 22 * this.pixelRatio;
      var sw = panelW - 24 * this.pixelRatio;
      var sh = panelH - 30 * this.pixelRatio;
      ctx.fillStyle = 'rgba(22, 101, 216, 0.12)';
      ctx.fillRect(sx + sw * 0.02, sy + sh * 0.08, sw * 0.3, sh * 0.52);
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.9)';
      ctx.strokeRect(sx + sw * 0.02, sy + sh * 0.08, sw * 0.3, sh * 0.52);
      ctx.beginPath();
      ctx.ellipse(sx + sw * 0.62, sy + sh * 0.34, sw * 0.15, sh * 0.22, 0, 0, Math.PI * 2);
      ctx.stroke();
      ctx.fillStyle = 'rgba(31, 41, 51, 0.88)';
      ctx.fillRect(sx + sw * 0.78, sy + sh * 0.12, sw * 0.16, sh * 0.44);
      var px = sx + sw * (0.36 + 0.08 * Math.sin(t * Math.PI * 2));
      var py = sy + sh * 0.34;
      ctx.fillStyle = 'rgba(22, 101, 216, 0.95)';
      ctx.fillRect(px - 1.3 * this.pixelRatio, py - 5 * this.pixelRatio, 2.6 * this.pixelRatio, 10 * this.pixelRatio);
      ctx.fillRect(px - 5 * this.pixelRatio, py - 1.3 * this.pixelRatio, 10 * this.pixelRatio, 2.6 * this.pixelRatio);
    } else if (demoType === 'ruler-style') {
      drawCaption('Ruler style variants');
      var rx = panelX + 8 * this.pixelRatio;
      var ry = panelY + 20 * this.pixelRatio;
      var rw = panelW - 16 * this.pixelRatio;
      var rh = panelH - 28 * this.pixelRatio;
      var rowH = rh / 3;
      var cStep = rw / 6;
      for (var ci = 0; ci < 6; ci += 1) {
        ctx.fillStyle = ci % 2 === 0 ? '#111827' : '#ffffff';
        ctx.fillRect(rx + ci * cStep, ry, cStep, rowH - 2);
      }
      for (var ti = 0; ti <= 6; ti += 1) {
        var tx = rx + ti * cStep;
        ctx.strokeStyle = 'rgba(31, 41, 51, 0.85)';
        ctx.beginPath();
        ctx.moveTo(tx, ry + rowH + 1);
        ctx.lineTo(tx, ry + rowH * 2 - 2);
        ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.82)';
      ctx.beginPath();
      ctx.moveTo(rx, ry + rowH * 2.5);
      ctx.lineTo(rx + rw, ry + rowH * 2.5);
      ctx.stroke();
      var marker = Math.floor((t * 6)) % 6;
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.95)';
      ctx.lineWidth = Math.max(1, 0.11 * this.pixelRatio);
      ctx.strokeRect(rx + marker * cStep + 1, ry + 1, cStep - 2, rowH - 4);
    } else if (demoType === 'margins') {
      drawCaption('Margin controls');
      var gx = panelX + 10 * this.pixelRatio;
      var gy = panelY + 20 * this.pixelRatio;
      var gw = panelW - 20 * this.pixelRatio;
      var gh = panelH - 30 * this.pixelRatio;
      var inset = Math.max(5, 3 * this.pixelRatio + pulse * 4 * this.pixelRatio);
      ctx.strokeStyle = 'rgba(31, 41, 51, 0.62)';
      ctx.lineWidth = Math.max(1, 0.1 * this.pixelRatio);
      ctx.strokeRect(gx, gy, gw, gh);
      ctx.setLineDash([4 * this.pixelRatio, 3 * this.pixelRatio]);
      ctx.strokeStyle = 'rgba(22, 101, 216, 0.9)';
      ctx.strokeRect(gx + inset, gy + inset, gw - inset * 2, gh - inset * 2);
      ctx.setLineDash([]);
      var ax = gx + gw * 0.5;
      ctx.beginPath();
      ctx.moveTo(ax, gy + 2);
      ctx.lineTo(ax, gy + inset - 1);
      ctx.moveTo(ax, gy + gh - 2);
      ctx.lineTo(ax, gy + gh - inset + 1);
      ctx.stroke();
    }
    ctx.restore();
  };

  ScaleBarBuilder.prototype.stepGuide = function (delta) {
    if (!this.guideActive) {
      return;
    }
    var next = this.guideStepIndex + (delta > 0 ? 1 : -1);
    if (next >= this.guideSteps.length) {
      this.stopGuide(true);
      return;
    }
    this.guideStepIndex = clamp(next, 0, Math.max(0, this.guideSteps.length - 1));
    this.renderGuideStep();
  };

  ScaleBarBuilder.prototype.startGuide = function (manual, mode) {
    this.guideMode = String(mode || 'quick').toLowerCase() === 'in-depth' ? 'in-depth' : 'quick';
    this.guideSteps = this.getGuideSteps(this.guideMode);
    this.guideStepIndex = 0;
    this.guideActive = true;
    if (this.controls.guideOverlay) {
      this.controls.guideOverlay.hidden = false;
    }
    this.renderGuideStep();
    if (manual) {
      this.setStatus((this.guideMode === 'in-depth' ? 'In-depth guide started.' : 'Guide started.') + ' Use Next/Back, or Skip to close.', false);
    }
  };

  ScaleBarBuilder.prototype.stopGuide = function (markSeen) {
    this.guideActive = false;
    this.clearGuideAnimationTimer();
    if (this.controls.guideOverlay) {
      this.controls.guideOverlay.hidden = true;
    }
    this.clearGuideHighlight();
    this.clearGuideSpotlight();
    if (markSeen) {
      try {
        localStorage.setItem(GUIDE_SEEN_STORAGE_KEY, '1');
      } catch (error) {
        // ignore storage errors
      }
    }
  };

  ScaleBarBuilder.prototype.maybeStartGuideOnFirstVisit = function () {
    var seen = false;
    try {
      seen = localStorage.getItem(GUIDE_SEEN_STORAGE_KEY) === '1';
    } catch (error) {
      seen = false;
    }
    if (seen) {
      return;
    }
    this.startGuide(false, 'quick');
  };

  
})();
